import {
  Expose, Exclude, Transform,
} from 'class-transformer';
import moment from 'moment';
import { formatNoValueToDash } from 'utils/utils';
import { AppConstants } from 'constants/app-constants.enum';
import { SaleType } from './sale-type.enum';
import { CatalogueBase } from './catalogue-base';

@Exclude()
export class Catalogue implements CatalogueBase {
  @Expose()
  id: number;

  @Expose()
  userId: number;

  @Expose()
  title: string;

  // Keep the value for catalogue update
  @Expose()
  saleStartDate: string;

  // Formatted sale start date
  @Expose()
  @Transform((value, obj) => obj.saleStartDate && moment(obj.saleStartDate).format(AppConstants.DateFormat))
  saleStartDateDesc: string;

  @Expose()
  saleEndDate: string;

  @Expose()
  @Transform((value, obj) => obj.saleEndDate && moment(obj.saleEndDate).format(AppConstants.DateFormat))
  saleEndDateDesc: string;

  @Expose()
  listingStartDate: string;

  @Expose()
  @Transform((value, obj) => obj.listingStartDate && moment(obj.listingStartDate).format(AppConstants.DateFormat))
  listingStartDateDesc: string;

  @Expose()
  listingEndDate: string;

  @Expose()
  @Transform((value, obj) => obj.listingEndDate && moment(obj.listingEndDate).format(AppConstants.DateFormat))
  listingEndDateDesc: string;

  @Expose()
  listedAnimals: number;

  @Expose()
  flock: string;

  @Expose()
  city: string;

  @Expose()
  state: string;

  @Expose()
  postcode: number;

  @Expose()
  saleType: SaleType;

  @Expose()
  @Transform((value, obj) => formatNoValueToDash(obj.saleType))
  saleTypeDesc: SaleType;

  @Expose()
  isActive: boolean;
}

@Exclude()
export class Breeders {
  @Expose()
  firstName: string;

  @Expose()
  lastName: string;

  @Expose()
  userId: string;

  @Expose()
  email: string;
}
